
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/edzeb",
      function () {
        return require("private-next-pages/case-study/edzeb.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/edzeb"])
      });
    }
  